import React, { useState, useEffect } from "react";
import { apiClient } from "../../services/api/apiClient";
import EditIcon from "../../assets/Edit.svg";
import DeleteIcon from "../../assets/Delete.svg";

const DuctSystemTable = ({
  ductSubmittalId,
  refreshTrigger,
  onDelete,
  onEdit,
}) => {
  const [ductSystems, setDuctSystems] = useState([]);

  useEffect(() => {
    const fetchDuctSystem = async () => {
      try {
        const response = await apiClient.get(`/duct-system/${ductSubmittalId}`);

        // ResponseHelper.success wraps data in response.data.data
        const systems =
          response.data.data?.systems || response.data.systems || [];
        console.log("Systems:", systems);
        setDuctSystems(Array.isArray(systems) ? systems : []);
      } catch (error) {
        console.error("Error fetching systems:", error);
        setDuctSystems([]);
      }
    };

    if (ductSubmittalId) {
      fetchDuctSystem();
    }
  }, [ductSubmittalId, refreshTrigger]);

  // Responsive grid template shared by the header and every row so they stay
  // aligned. Flexible minmax/fr tracks let the columns shrink to fit narrower
  // screens (instead of overflowing and pushing Actions off-screen), while the
  // min widths keep each column readable. Content wraps within its cell.
  const gridTemplateColumns =
    "minmax(110px, 1.2fr) minmax(80px, 0.9fr) minmax(90px, 1fr) minmax(90px, 1fr) minmax(70px, 0.8fr) minmax(80px, 0.8fr) minmax(90px, 1.2fr) minmax(52px, 0.6fr)";
  const gridGap = "16px";

  return (
    <div
      className="submittal-details"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        padding: "20px",
        border: "1px solid #6B7280",
        borderRadius: "20px",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns,
          gap: gridGap,
          padding: "13.5px 0 15px 0",
          borderBottom: "1px solid #D1D5DB",
        }}
      >
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          System Name
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Category
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Pressure Class
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Seal Class
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Wrap
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Liner
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Notes
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Actions
        </p>
      </div>
      {Array.isArray(ductSystems) &&
        ductSystems.map((system, systemIndex) => (
          <div
            key={system.id}
            style={{
              borderTop: systemIndex !== 0 ? "1px solid #D1D5DB" : "none",
            }}
          >
            {system.categories &&
              system.categories.map((category, categoryIndex) => (
                <div
                  key={category.id}
                  style={{
                    display: "grid",
                    gridTemplateColumns,
                    gap: gridGap,
                    padding: "8px 0",
                    borderTop:
                      categoryIndex !== 0 ? "1px solid #E5E7EB" : "none",
                  }}
                >
                  {/* System Name - Only show on first category */}
                  {categoryIndex === 0 && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "4.5px",
                        padding: "0 5px",
                        minWidth: 0,
                      }}
                    >
                      <p
                        style={{
                          color: "#111827",
                          fontSize: "14px",
                          fontFamily: "Inter",
                          fontWeight: 400,
                          overflowWrap: "break-word",
                        }}
                      >
                        {system.title}
                      </p>
                    </div>
                  )}
                  {categoryIndex > 0 && <div></div>}

                  {/* Category Name */}
                  <span
                    style={{
                      color: "#6B7280",
                      fontSize: "14px",
                      fontFamily: "Inter",
                      fontWeight: 400,
                      minWidth: 0,
                      overflowWrap: "break-word",
                    }}
                  >
                    {category.name}
                  </span>

                  {/* Pressure Class */}
                  <p
                    style={{
                      color: "#6B7280",
                      fontSize: "14px",
                      fontFamily: "Inter",
                      fontWeight: 400,
                      minWidth: 0,
                      overflowWrap: "break-word",
                    }}
                  >
                    {category.pressure_class_type_name}
                  </p>

                  {/* Seal Class */}
                  <p
                    style={{
                      color: "#6B7280",
                      fontSize: "14px",
                      fontFamily: "Inter",
                      fontWeight: 400,
                      minWidth: 0,
                      overflowWrap: "break-word",
                    }}
                  >
                    {category.seal_class_name}
                  </p>

                  {/* Wrap */}
                  <p
                    style={{
                      color: "#6B7280",
                      fontSize: "14px",
                      fontFamily: "Inter",
                      fontWeight: 400,
                      minWidth: 0,
                      overflowWrap: "break-word",
                    }}
                  >
                    {category.wrap_name}
                  </p>

                  {/* Liner */}
                  <p
                    style={{
                      color: "#6B7280",
                      fontSize: "14px",
                      fontFamily: "Inter",
                      fontWeight: 400,
                      minWidth: 0,
                      overflowWrap: "break-word",
                    }}
                  >
                    {category.liner_name || "N/A"}
                  </p>

                  {/* Notes */}
                  <p
                    style={{
                      color: "#6B7280",
                      fontSize: "14px",
                      fontFamily: "Inter",
                      fontWeight: 400,
                      minWidth: 0,
                      overflowWrap: "break-word",
                    }}
                  >
                    {category.notes}
                  </p>

                  {/* Actions - Only show on first category */}
                  {categoryIndex === 0 && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <img
                        src={EditIcon}
                        alt="Edit"
                        style={{ cursor: "pointer" }}
                        onClick={() => onEdit && onEdit(system)}
                      />
                      <img
                        src={DeleteIcon}
                        alt="Delete"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          onDelete && onDelete(system.id, system.title)
                        }
                      />
                    </div>
                  )}
                  {categoryIndex > 0 && <div></div>}
                </div>
              ))}
          </div>
        ))}
    </div>
  );
};

export default DuctSystemTable;
